import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
// import { createLogger } from 'redux-logger'
import getsMenu from './reducers/menu';
import getsListProducts from './reducers/goodsList';
import getsItemData from './reducers/goodItem';
import wishCompareCart from './reducers/wishCompareCart';
import getUser from './reducers/user';
import getCheckoutInfo from './reducers/checkout';
import getsHistoryItems from './reducers/itemHistory';
// import {authentication} from './reducers/users.jsx'
// const loggerMiddleware = createLogger()
const middleware = [thunkMiddleware];

export default function configureStore(preloadedState) {
  // console.log("preloaded state ",preloadedState);
  return createStore(
    combineReducers({
      menu: getsMenu,
      goods: getsListProducts,
      goodItem: getsItemData,
      wishCompareCart: wishCompareCart,
      user: getUser,
      checkoutInfo: getCheckoutInfo,
      historyItems: getsHistoryItems,
      // authetication:authentication
    }),
    applyMiddleware(...middleware)
  );
}
